import { memo } from 'react';

import { merge } from '@/components';
import { Text } from '@/components/core';
import { ArrowShortIcon } from '@/components/icons';
import { DivProps } from '@/utils';

const IDescendingCard = ({ className, children, ...rest }: DivProps) => {
  return (
    <div className={merge('flex w-full items-center gap-1', className)} {...rest}>
      <ArrowShortIcon rotation="down" />
      <Text>Descending</Text>
      {children}
    </div>
  );
};

export const DescendingCard = memo(IDescendingCard) as typeof IDescendingCard;
